import React from 'react';
import { CdnIcon } from '@shared/ui';
import { FareFamilyOptionsType, FareFeaturePaymentType } from '@websky/graphql';
import { FareGroupVariant } from '../model/types';

export const getFareOptionTooltipTitle = (title: string, shortDescription?: string) =>
	shortDescription ? `${title} - ${shortDescription}` : title;

export const getOptionTitle = ({
	title,
	value,
	size,
	isKeyOption,
	variant
}: {
	title: string;
	value: string;
	size: string;
	isKeyOption: boolean;
	variant: FareGroupVariant;
}) => {
	let resultTitle = '';

	if (variant === 'small') {
		if (isKeyOption) {
			/** Для опций в плитках */
			resultTitle = value || title;
		} else {
			/** Для опций в списке */
			resultTitle = title;
		}
	}

	if (variant === 'big') {
		resultTitle = [value, size].filter(Boolean).join(',\n') || title;
	}

	return resultTitle;
};

export const renderFeaturePaymentTypeIcon = (type: FareFeaturePaymentType): React.ReactNode => {
	const icons: Partial<Record<FareFeaturePaymentType, React.ReactNode>> = {
		[FareFeaturePaymentType.Free]: <CdnIcon icon="Info/Item Icluded" />,
		[FareFeaturePaymentType.Pay]: <CdnIcon icon="Info/Item Paid" />,
		[FareFeaturePaymentType.NotAvailable]: <CdnIcon icon="Info/Not included" />
	};

	return icons[type];
};

export const renderFareOptionsTypeIcon = (type: FareFamilyOptionsType): React.ReactNode => {
	const icons: Partial<Record<FareFamilyOptionsType, React.ReactNode>> = {
		[FareFamilyOptionsType.VipService]: <CdnIcon icon="Services/Business Lounge" />,
		[FareFamilyOptionsType.CarryOn]: <CdnIcon icon="Baggage/Cabin" />,
		[FareFamilyOptionsType.Baggage]: <CdnIcon icon="Baggage/Checked-in" />,
		[FareFamilyOptionsType.SeatRegistration]: <CdnIcon icon="Services/Seat Selection" />,
		[FareFamilyOptionsType.Meal]: <CdnIcon icon="Services/Meal" />,
		[FareFamilyOptionsType.Refundable]: <CdnIcon icon="Services/Refundable" />,
		[FareFamilyOptionsType.Exchangeable]: <CdnIcon icon="Services/Exchangeable" />,
		[FareFamilyOptionsType.SportsEquipment]: <CdnIcon icon="Baggage/Sport Equipment" />,
		[FareFamilyOptionsType.OnlineRegistration]: <CdnIcon icon="Document/Boarding pass" />
	};

	return icons[type];
};
